import React from 'react';

export default function SageSLogoIcon({
    size = 18,
    color = '#33C78F',
    ...props
}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#sageLogoClip)">
                <path
                    d="M4.57787 9C4.75403 9 4.91717 9.09417 5.00463 9.24707L8.37182 15.1406C8.5586 15.468 8.32201 15.875 7.94506 15.875H5.14818C4.97203 15.875 4.80888 15.7808 4.72143 15.6279L1.35424 9.73438C1.16746 9.40705 1.40405 9 1.781 9H4.57787ZM6.73705 2.125C6.91393 2.125 7.07761 2.22014 7.16479 2.37402L13.6589 13.8555C13.7467 14.0106 13.7431 14.2014 13.6501 14.3535L12.864 15.6396C12.7748 15.7856 12.6161 15.875 12.4451 15.875H10.8464C10.6695 15.875 10.5059 15.7799 10.4187 15.626L3.92553 4.14453C3.83779 3.9894 3.84045 3.79858 3.93334 3.64648L4.71947 2.36035C4.80864 2.21445 4.96744 2.12509 5.13842 2.125H6.73705ZM12.4353 2.125C12.6113 2.12509 12.7736 2.21938 12.8611 2.37207L16.2292 8.26562C16.4158 8.5929 16.1793 8.99994 15.8025 9H13.0046C12.8287 8.99986 12.6663 8.90561 12.5788 8.75293L9.21166 2.85938C9.02473 2.53208 9.26055 2.12516 9.63744 2.125H12.4353Z"
                    fill={color}
                />
            </g>

            <defs>
                <clipPath id="sageLogoClip">
                    <rect
                        width="15.0472"
                        height="13.75"
                        fill="white"
                        transform="translate(1.28903 2.125)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}